function parseBooleanEnv(value: string | undefined): boolean {
  if (value == null || value === '') return false
  return ['true', '1', 'yes'].includes(value.toLowerCase())
}

/** Build-time feature flags (from env vars baked in at `vite build` / dev server start). */
export const featureFlags = {
  enableFastenConnect: parseBooleanEnv(import.meta.env.VITE_ENABLE_FASTEN_CONNECT),
} as const
